const state = {
  email: "",
  locid: "",
  isAuthorizedForRetry: false,
}

const getters = {
	universalLoginEmail(state) {
		return state.email;
	},
	locid(state) {
		return state.locid;
	},
	isAuthorizedForRetry(state) {
		return state.isAuthorizedForRetry;
	},
}

const actions = {
  setEmail(context, value) {
    context.commit("setEmail", value);
  },
  clearEmail(context) {
    context.commit("clearEmail");
  },
  setLocid(context, value) {
    context.commit("setLocid", value);
  },
  clearLocid(context) {
    context.commit("clearLocid");
  },
  setAuthorizedForRetry(context, isAuthorized) {
    context.commit('setAuthorizedForRetry', isAuthorized)
  },
}

const mutations = {
  setEmail(state, value) {
    state.email = value;
  },
  clearEmail(state) {
    state.email = "";
  },
  setLocid(state, value) {
    state.locid = value;
  },
  clearLocid(state) {
    state.locid = "";
  },
  setAuthorizedForRetry(state, isAuthorized) {
    state.isAuthorizedForRetry = isAuthorized
  },
}

export default {
  state,
  getters,
  actions,
  mutations,
};
